import clsx from 'clsx';
import React from 'react';
import { AlaramIcon } from '../../../Assets/icons';
import CommonCard from '../../General/CommonCard';
import SlotsDetail from '../../General/SlotsDetail';
import PopoverBox from '../Popover';
import classes from './TimeSelectorCard.module.css';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
const TimeSelectorCard = ({
  className,
  value = 'hh/mm',
  slots,
  disabled,
  slotsIndicator,
  setter,
  onBlur,
  loading,
  ...rest
}) => {
  let content = <SlotsDetail slots={slots} value={value} setter={setter} />;
  if (!disabled || Object.keys(slots).length === 0) {
    content = (
      <div className={classes.fallback}>
        <h3>First select valid date</h3>
      </div>
    );
  }
  if (slotsIndicator) {
    content = (
      <div className={classes.fallback}>
        <h3>{slotsIndicator}</h3>
      </div>
    );
  }
  return (
    <>
      <CommonCard
        className={clsx(className, classes.card, {
          [classes.disabled]: loading
        })}
        {...rest}>
        {!loading ? (
          <span className={clsx(classes.wrapper)}>
            <span
              className={clsx(classes.value, {
                [classes.placeholder]: !value?.timeFrom
              })}>
              {value?.timeFrom || 'hh/mm'}
            </span>
            {/* <PopoverBox list={<SlotsDetail list={slots} value={value} setter={setter} />}> */}
            <PopoverBox list={content} className={classes.slotsWrapper}>
              <span className={classes.icon}>
                <AlaramIcon />
              </span>
            </PopoverBox>
          </span>
        ) : (
          <p className={classes.loading}>loading...</p>
        )}
      </CommonCard>
    </>
  );
};

export default TimeSelectorCard;
